<template>
  <div class="contactUs">
    <div class="container wrapper">
      <div class="content">
        <div class="wx">
          <p>微信：</p>
          <img src="../assets/img/qrcode.png" alt="">
        </div>
        <div class="email">
          <p>邮箱：kexinjiaoyou@126.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContactUs',
  components: {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scope>
.contactUs {
  width: 100%;
  height: calc(100% - 154.7px);
  .container {
    height: 100%;
    padding-bottom: 110px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      position: relative;
      height: 350px;
      background-color: white;
      border-radius: 17px;
      width: 640px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      padding-left: 148px;
      .wx {
        display: flex;
        justify-content: start;
        align-items: center;
        p {
          margin-right: 20px;
        }
        img {
          width: 128px;
          height: 128px;
        }
      }
      p {
        font-size: 28px;
        color: black;
      }
    }
  }
}
</style>
